<template>
  <section class="form-underwriting width-700">
    <el-form
      ref="form"
      :rules="rules"
      class="form-container"
      :model="formData">
      <div class="form-item">
        <span>Contract Period</span>
        <el-form-item prop="contr_prd">
          <v-select
            v-model="formData.contr_prd"
            :list="localAllOptions.period" />
        </el-form-item>
      </div>
      <div class="form-item">
        <span>Building Age</span>
        <el-form-item prop="bldg_age">
          <v-select
            v-model="formData.bldg_age"
            :list="localAllOptions.bldg_ages" />
        </el-form-item>
      </div>
      <div class="form-item">
        <span>Total Contract Sum</span>
        <el-form-item
          ref="tol_contr_sum"
          prop="tol_contr_sum">
          <v-input
            v-model.number="formData.tol_contr_sum"
            append="HK$" />
        </el-form-item>
      </div>
      <div class="form-item">
        <span>Material Damage Coverage </span>
        <el-form-item
          ref="mat_dam_cvr_ind"
          prop="mat_dam_cvr_ind">
          <v-radio-group
            v-model="formData.mat_dam_cvr_ind"
            :border="true"
            :list="yesNoOptions" />
        </el-form-item>
      </div>
      <div class="form-item">
        <span>Third Party Liability Coverage </span>
        <el-form-item prop="tp_lia_cvr_ind">
          <v-radio-group
            v-model="formData.tp_lia_cvr_ind"
            :border="true"
            :list="yesNoOptions" />
        </el-form-item>
      </div>

      <div class="form-item">
        <span>Third Party Liability Limit</span>
        <el-form-item
          ref="tppd_limit_amt"
          prop="tppd_limit_amt">
          <v-select
            v-model="formData.tppd_limit_amt"
            :disabled="formData.tp_lia_cvr_ind != 1"
            :list="localAllOptions.limit_of_liability" />
        </el-form-item>
      </div>
      <div class="form-item">
        <span>Outdoor Work or Scaffolding Work</span>
        <el-form-item prop="outdoor_wk_ind">
          <v-radio-group
            v-model="formData.outdoor_wk_ind"
            :border="true"
            :list="yesNoOptions" />
        </el-form-item>
      </div>
      <!-- <div class="form-item">
        <span>Contract Sum of Out-Door Work</span>
        <el-form-item prop="outdoor_wk_sum">
          <v-input
            v-model="formData.outdoor_wk_sum"
            :disabled="formData.outdoor_wk_ind != 1"
            append="HKD" />
        </el-form-item>
      </div> -->
      <div
        v-if="formData.outdoor_wk_ind == 1"
        class="form-item">
        <span>Total Contract Value of Outdoor Work and/or Scaffolding Work</span>
        <el-form-item prop="scaffolding_wk">
          <v-select
            v-model="formData.scaffolding_wk"
            :list="localAllOptions.scaffolding_wk" />
        </el-form-item>
      </div>

      <div class="form-item">
        <span>Employee Compensation</span>
        <el-form-item prop="employee_ind">
          <v-radio-group
            v-model="formData.employee_ind"
            :border="true"
            :list="yesNoOptions" />
        </el-form-item>
      </div>
      

      <!-- <h3>More Benefits</h3>
      <div class="form-item">
        <v-checkbox-group
          v-model="formData.benefits"
          :block="true"
          :list="localAllOptions.benefits" />
      </div> -->
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
import {mapState} from 'vuex'

export default {
  name: 'FormUnderwriting',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const checkOutdoor = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { outdoor_wk_ind } = this.formData
      if(outdoor_wk_ind == 1 && !valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    const checkLimit = (rule, value, callback) => {
      const valueResult = value !== null && value !== ''
      const { tp_lia_cvr_ind } = this.formData
      if(tp_lia_cvr_ind == 1 && !valueResult) {
        callback(new Error(this.$t('placeholder.input')))
      }
      callback()
    }
    return {
      formData: {
        // class_id: 24,
        // customer_id: '',
        contr_prd: '',
        bldg_age: '',
        tol_contr_sum: '',
        mat_dam_cvr_ind: '',
        tp_lia_cvr_ind: '',
        tppd_limit_amt: '',
        outdoor_wk_ind: '',
        scaffolding_wk: 0,
        outdoor_wk_sum: '',
        employee_ind: '',
        // benefits: []
      },
      extraRules: {
        tppd_limit_amt: [
          { validator: checkLimit, trigger: ['change', 'blur'] }
        ],
        outdoor_wk_sum: [
          { validator: checkOutdoor, trigger: ['change', 'blur'] }
        ]
      }
    }
  },
  computed: {
    ...mapState('errorfield', ['errorField']),
    localAllOptions() {
      return this.allOptions24
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        Object.keys(this.formData).some(key => {
          if(key in val) {
            this.formData[key] = val[key]
          }
        })
      }
    },
    errorField:{
      immediate:true,
      deep:true,
      handler(val){
        if(val)
        {
          this.errScrollToValidDom(val)

        }
      }
    }
  },
  methods: {
    submitForm() {
      // 表單校驗
      // this.formData.tol_contr_sum = parseInt(this.formData.tol_contr_sum)
      this.$refs.form.validate(valid => {
        if(valid) {
          const { scaffolding_wk, outdoor_wk_ind } = this.formData
          this.$emit('getFormData', {
            ...this.formData,
            scaffolding_wk: outdoor_wk_ind? scaffolding_wk: 0, 
            class_id: 24
          })
        }
      })
      
    }
  }
}
</script>
<style lang="scss" scoped>
.form-underwriting {
  position: relative;
  // width: 700px;
}
</style>